import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

export class BirthMonthStep extends React.Component<IStepProps, IStepState> {
    state: IStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }

    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.primaryDriver.birthMonth = value;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.BIRTH_DAY);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    getSelectedClass(optionValue: string): string {
        if (optionValue === this.props.model.primaryDriver.birthMonth) {
            return "selected";
        }

        return "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        return <React.Fragment>
            <LogStep lastStep="BirthYear" nextStep="BirthDay" stepNumber={QuoteFormEventType.BirthMonthStep} sectionName="BirthMonth" wizardName="AutoWizard" logStep={true}/>
            <div id="BirthMonthStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Birth Month</h3>
                   <div id="BirthMonth">
                       <div className="touch-list fourColumn">
                           <div className="touch-list-option"><a className={this.getSelectedClass("1")} id="birthMonth_01" data-value="1" onClick={this.handleOnClick}>JAN</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("2")} id="birthMonth_02" data-value="2" onClick={this.handleOnClick}>FEB</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("3")} id="birthMonth_03" data-value="3" onClick={this.handleOnClick}>MAR</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("4")} id="birthMonth_04" data-value="4" onClick={this.handleOnClick}>APR</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("5")} id="birthMonth_05" data-value="5" onClick={this.handleOnClick}>MAY</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("6")} id="birthMonth_06" data-value="6" onClick={this.handleOnClick}>JUN</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("7")} id="birthMonth_07" data-value="7" onClick={this.handleOnClick}>JUL</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("8")} id="birthMonth_08" data-value="8" onClick={this.handleOnClick}>AUG</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("9")} id="birthMonth_09" data-value="9" onClick={this.handleOnClick}>SEP</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("10")} id="birthMonth_10" data-value="10" onClick={this.handleOnClick}>OCT</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("11")} id="birthMonth_11" data-value="11" onClick={this.handleOnClick}>NOV</a></div>
                           <div className="touch-list-option"><a className={this.getSelectedClass("11")} id="birthMonth_12" data-value="12" onClick={this.handleOnClick}>DEC</a></div>
                       </div>
                   </div>
            </div>
        </React.Fragment>;
    }
}